import { UpdateOrganizationDroneDto } from '../request-models/update-organization-drone-dto.model';
import { DroneRequest } from '../request-models/drone-request.model';

/**
 * Builds the hub request body from the drone form's DTO. Sends only the allowlisted fields that are set,
 * so an update stays partial, and renames the web's `registrationNumber` to the hub's `nNumber`.
 * `null` (clear the field) is kept; only `undefined` is dropped.
 */
export function toDroneRequest(dto: UpdateOrganizationDroneDto): DroneRequest {
  const fields: DroneRequest = {
    name: dto.name,
    manufacturerId: dto.manufacturerId,
    modelId: dto.modelId,
    serialNumber: dto.serialNumber,
    nNumber: dto.registrationNumber,
    remoteId: dto.remoteId,
    firmwareVersion: dto.firmwareVersion,
    status: dto.status,
  };
  const request: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(fields)) {
    if (value !== undefined) {
      request[key] = value;
    }
  }
  return request as DroneRequest;
}

/**
 * The value to send for an optional drone form field (registration, remote ID, firmware):
 * - unchanged from `original` (including blank on create): `undefined`, so it isn't sent;
 * - emptied while editing (it had a value): `null`, so the hub clears it;
 * - otherwise the entered value.
 * Never use this for required fields; they must not be sent as `null`.
 */
export function clearableFieldValue(current: string | null | undefined, original: string | null | undefined): string | null | undefined {
  const entered = current?.trim() ? current : '';
  const before = original?.trim() ? original : '';
  if (entered === before) {
    return undefined;
  }
  return entered === '' ? null : entered;
}
